export const ACTIVE_USER_COOKIE_NAME = "active_user";
